import React from "react";

import { GatsbyImage } from "gatsby-plugin-image";
import { ArrowUpRight } from "react-feather";
import styled, { useTheme } from "styled-components";
import Button from "../Buttons/Button";
import { OutboundLink } from "gatsby-plugin-google-gtag";

const StyledCard = styled(OutboundLink)`
  text-decoration: none;
  display: flex;
  height: 100%;
  padding: 1em;
  font-size: var(--fz-sm);
  border: var(--border-width-hard) solid ${({ theme }) => theme.colors.dborder};
  transform: translateZ(0);
  transition: all 0.4s ease;
  box-sizing: border-box;
  cursor: pointer;
  font-family: "Poppins";
  font-weight: 400;
  color: ${({ theme }) => theme.colors.descfont};

  .contentWithTitle {
    ${({ theme }) => theme.mixins.flex.flexColumnStart};
    justify-content: space-between;
    width: 100%;
    height: 100%;
  }

  h1 {
    font-size: var(--fz-xl);
    font-family: var(--font-serif-ogg);
    font-weight: 500;
    margin: 0.4em 0 0 0;
    line-height: 1.1em;
    color: ${({ theme }) => theme.colors.primary};
  }

  .desc {
    color: ${({ theme }) => theme.colors.descfont};
    font-size: var(--fz-sm);
    font-weight: 400;
  }

  .footer {
    ${({ theme }) => theme.mixins.flex.flexBetween};
  }

  @media (min-width: 400px) {
    font-size: var(--fz-md);
  }

  @media (min-width: 800px) {
    padding: 1.5em;
    .desc {
      font-size: var(--fz-md);
    }
    h1 {
      font-size: var(--fz-xxl);
    }
  }

  :hover {
    /* border-bottom: var(--border-width-hard) solid
      ${({ theme }) => theme.colors.secondary}; */
    /* box-shadow: 0 0 10px ${({ theme }) => theme.colors.gradientone}; */
  }
`;

const StyledImage = styled(GatsbyImage)`
  img {
    border-radius: 5px;
    margin: 0 auto;
  }
  width: 100%;
  height: 100%;
  max-width: 60px;
  max-height: 60px;

  @media (min-width: 400px) {
    max-width: 60px;
    max-height: 60px;
  }

  @media (min-width: 800px) {
    max-width: 100px;
    max-height: 100px;
  }
`;

const VarticalCard = ({
  darkImg,
  lightImg,
  cardLink,
  buttonLink,
}: {
  darkImg: any;
  lightImg: any;
  cardLink: string;
  buttonLink: string;
}) => {
  const { mode } = useTheme();
  return (
    <StyledCard href={cardLink} target="_blank">
      <div className="contentWithTitle">
        <div>
          <StyledImage
            image={mode === "dark" ? darkImg : lightImg}
            alt="toolpooldark"
          />
          <h1>Toolpool</h1>
          <div className="desc">
            One-Stop solution with all tools for your work
          </div>
        </div>
        <div className="footer">
          <Button link={buttonLink} Icon={ArrowUpRight} name="See all" />
        </div>
      </div>
    </StyledCard>
  );
};

export default VarticalCard;
